import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveCustomerNoteInput } from './SaveCustomerNoteInput';
import { SaveCustomerNoteOutput } from './SaveCustomerNoteOutput';

export class SaveCustomerNoteService extends HttpServiceBase {

  handle = (input: SaveCustomerNoteInput): Promise<Result<SaveCustomerNoteOutput> | null> => {
    const promise = this.http.post<Result<SaveCustomerNoteOutput>, SaveCustomerNoteInput>(`${this.baseUrlSislogApi}/v2/customer-note`, input);
    return promise;
  }
}